import React, { FC, Fragment, createElement } from 'react';
import { Transition, Menu } from '@headlessui/react';

export interface CustomDropdownProps {
  children?: React.ReactNode;
  buttonElement?: JSX.Element;
  buttonClassNames?: (open?: boolean) => string | string;
  menuWrapperClassNames?: string;
  menuClassNames?: (open?: boolean) => string | string;
}

const CustomDropDown: FC<CustomDropdownProps> = ({
  buttonElement,
  buttonClassNames,
  menuWrapperClassNames,
  menuClassNames,
  children,
}) => {
  return (
    <Menu as="div" className="relative" data-testid="atom-custom-dropdown">
      {({ open }) => (
        <>
          <Menu.Button as="div" className={buttonClassNames ? buttonClassNames(open) : ''} data-testid="atom-custom-dropdown-button">
            {buttonElement}
          </Menu.Button>

          {createElement(
            Transition as any,
            {
              show: open,
              as: Fragment,
              enter: 'transition ease-out duration-100',
              enterFrom: 'transform origin-top scale-y-0',
              enterTo: 'transform origin-top scale-y-100',
              leave: 'transition ease-in duration-100',
              leaveFrom: 'transform origin-top scale-y-100',
              leaveTo: 'transform origin-top scale-y-0',
            },
            createElement(
              Menu.Items as any,
              { className: menuWrapperClassNames, 'data-testid': 'atom-custom-dropdown-menu' },
              <div className={menuClassNames ? menuClassNames(open) : ''}>{children}</div>,
            ),
          )}
        </>
      )}
    </Menu>
  );
};

export default CustomDropDown;
